// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';

// Types
type $Props = $Translate & {
  item: $Model<'RegattaResultDiploma'> | $ModelUpsertParams<'RegattaResultDiploma'>;
};

const RegattaResultDiplomaFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Content')}
            name={'Content'}
            required
            type={'textarea'}
            value={item.Content}
          />
        </Col>
      </Row>
    </>
  );
};

export default RegattaResultDiplomaFieldsView;
